module.exports = __webpack_public_path__ + "img/SOKAL-WEB-112322-CreativeAnalysis-Cadillac-Modern.debe2dd1.jpeg";